import * as actions from "./actions";
import * as mutations from "./mutations";
import * as getters from "./getters";

const state = {
  eventDetails: null,
  loading: false,
  snackbarContent: null,
  expirationDialog: false,
  queue: null,
  finishedQueue: false,
  storeDetails: null,
  namedTickets: false,
  selectedLanguage: "pt",
  firstPayment: false,
  pendingOrder: false,
  orderProducts: [],
};

export default {
  state,
  actions,
  mutations,
  getters,
};
